export default __webpack_public_path__ + "static/media/yacht_leaving_during_sunset.703a0f8c.jpg";